import { FloatingButtonId } from '../enums/elementId';
import { AvcResult } from '@vfde-sails/avc-core';
import { Button, IButtonProperties } from '@vfde-brix/ws10/button';
import { ProductType } from '../enums/product';
import { UserInfo } from '../container/App/interface';
import { OFFER_SUMMARY_CARD_BUTTON_CLASSNAME } from '@vfde-brix/ws10/offer-summary-card';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';

/**
 * handleIconsPosition
 * @param changePosition
 * check the scroll to top page arrow style when there is floating button
 */
const handleIconsPosition = (changePosition: boolean) => {
    const contentFlyOut = document.querySelector(FloatingButtonId.FlayOutIcon) as HTMLElement;
    const anchorTopDiv = document.querySelector(FloatingButtonId.AnchorIcon) as HTMLElement;

    if (contentFlyOut) {
        contentFlyOut.style.paddingBottom = changePosition ? '171px' : '96px';
    }

    if (anchorTopDiv) {
        anchorTopDiv.style.bottom = changePosition ? '91px' : '10px';
    }
};

const handleButtonVisibility = () => {
    const [ priceButton ] = document.getElementsByClassName(OFFER_SUMMARY_CARD_BUTTON_CLASSNAME) || [];

    if (!priceButton) {
        return;
    }

    const hideButton =
        1024 < window.innerWidth ||
        // FIXME: Do NOT force cast this!
        10 < priceButton!.getBoundingClientRect().top;
    toggleElementVisibilityById(FloatingButtonId.FLOATING_NOTIFICATION, !hideButton);
    handleIconsPosition(!hideButton);
};

const resetButtonVisibility = () => {
    window.removeEventListener('scroll', handleButtonVisibility);
    window.removeEventListener('resize', handleButtonVisibility);
    toggleElementVisibilityById(FloatingButtonId.FLOATING_NOTIFICATION, false);
    handleIconsPosition(false);
};

export const handleShowFloatingButton = (show?: boolean) => {
    if (show) {
        // call this function in the reload case
        handleButtonVisibility();
        window.addEventListener('scroll', handleButtonVisibility);
        window.addEventListener('resize', handleButtonVisibility);
        return;
    }
    resetButtonVisibility();
};

export const updateFloatingMobileNotificationButton = (
    comp: Button | null,
    btnProps: Partial<IButtonProperties>,
    avcResult?: AvcResult,
    tariffId?: string,
    userInfo?: UserInfo
) => {
    if (
        !userInfo?.isFixed &&
        (!avcResult ||
            avcResult.fastest?.productType === ProductType.FIBRE ||
            !tariffId)
    ) {
        comp?.update(btnProps);
        handleShowFloatingButton(true);
        return;
    }
    handleShowFloatingButton(false);
};
